import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { BaseMenuService } from '@fry/lib/menu';
import { AuthService } from '@fry/lib/auth';
import { SecurityService } from '@fry/lib/security';
import { ConfigService } from '@fry/lib/config';
import { map } from 'rxjs/operators';
import { OrganisationService } from '@fry/lib/organisations';


@Injectable()
export class EportfolioMenu extends BaseMenuService {

    constructor(
      auth: AuthService,
      security: SecurityService,
      private config: ConfigService,
      private organisationService: OrganisationService,
    ) {
      super(auth, security);
    }

    cook() {
      return combineLatest([
        this.config.config$,
        this.auth.currentUser(),
        this.organisationService.getGeneralSetup(),
      ]).pipe(
        map(([config, currentUser, generalSetup]) => {
          const menu = [];
          if (generalSetup.showKaizenLink) {
            menu.push({
              id: 'eportfolio',
              abslink: `${config.server.urls.epf}/#/?org=${currentUser.organisation}`,
              title: $localize `risr/advance`
            })
          }
          return menu;
        })
      )
    }
}
